import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { AppLoaderComponent } from './app-loader.component';

@Injectable()
export class AppLoaderService {

  dialogRef: MatDialogRef<AppLoaderComponent>;

  constructor(private _matDialog: MatDialog) { }

  public show(): Observable<boolean> {
    if(!this.dialogRef) {
      this.dialogRef = this._matDialog.open(AppLoaderComponent, { closeOnNavigation: true, disableClose: true });
      return this.dialogRef.afterClosed();
    }
  }

  public hide() {
    if(this.dialogRef) 
      this.dialogRef.close();
    this.dialogRef = undefined;
  }
}
